import { useEffect, useReducer } from 'react';
import {
    addEmploymentReducer,
    stateContainsAllEmployees,
    stateContainsEmployee,
    stateContainsSomeButNotAllEmployees,
    stateContainsNoEmployees,
    EmployeeIdToEmploymentId,
    stateSelectAllState,
} from '@Page/SalaryRun/stateReducer';
import { EmployeeEmploymentRelationshipDTO } from '@Models/model.types';
import { SWRResponse } from 'swr';
import { ListResponse } from '@tlx/astro-shared';

export const useSelectableEmployees = (selectable: SWRResponse<ListResponse<EmployeeEmploymentRelationshipDTO>>) => {
    const [state, updateState] = useReducer(addEmploymentReducer, {
        selectedEmployees: new Map<number, number>(),
        selectableEmployees: new Map<number, number>(),
    });

    useEffect(() => {
        if (!selectable.isLoading) {
            updateState({ type: 'SelectAllLoading', value: false });
            if (selectable.data) {
                updateState({
                    type: 'CreateMap',
                    employeesToEmployments: selectable.data?.values.map((rel) => {
                        return {
                            employeeId: rel.employee.id,
                            employmentId: rel.employments[0].id,
                        };
                    }),
                });
            }
            //you have previously clicked selectAll, but it wasn't able to as it was loading
            if (state.clickedButSelectAllWasLoading) {
                updateState({ type: 'SelectAll' });
            }
        } else {
            updateState({ type: 'SelectAllLoading', value: true });
        }
    }, [selectable.isLoading, selectable.data]);

    const checkAllHandler = () => {
        if (stateContainsNoEmployees(state)) {
            updateState({
                type: 'SelectAll',
            });
        } else {
            updateState({
                type: 'UncheckAllEmployees',
            });
        }
    };

    const checkRowHandler = (employeeToEmployment: EmployeeIdToEmploymentId) => {
        if (stateContainsEmployee(state, employeeToEmployment.employeeId)) {
            updateState({
                type: 'UncheckSingleEmployee',
                employeeToEmployment,
            });
        } else {
            updateState({
                type: 'CheckSingleEmployee',
                employeeToEmployment,
            });
        }
    };

    const rowChecked = (employeeToEmployment: EmployeeIdToEmploymentId) =>
        stateContainsEmployee(state, employeeToEmployment.employeeId);

    const uncheckAllHandler = () => {
        updateState({
            type: 'UncheckAllEmployees',
        });
    };

    const changeEmploymentHandler = (employeeToEmployment: EmployeeIdToEmploymentId) => {
        updateState({
            type: 'UpdateMap',
            employeeToEmployment,
        });
    };

    return {
        state,
        allChecked: stateContainsAllEmployees(state),
        someChecked: stateContainsSomeButNotAllEmployees(state),
        selectAllState: stateSelectAllState(state),
        isRowChecked: rowChecked,
        onCheckAll: checkAllHandler,
        onCheckRow: checkRowHandler,
        onChangeEmployment: changeEmploymentHandler,
        onUncheckAll: uncheckAllHandler,
    };
};
